import api from "./api";

const stripeProductLists = {
	get() {
		return api.get('stripe-product-list')
	},
};

export default stripeProductLists